module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwAQMAAABtzGvEAAAABlBMVEUAAABmZmZ+SwYRAAAAAXRSTlMAQObYZgAAABNJREFUGNNjGPyA8f//Bhg16AEARrAE/47MvVkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/shop_reduce.png
// module id = 50
// module chunks = 38